var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginToPortal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 20.7C23.91 21.09 23.91 21.71 24.3 22.1L26.2 24H17C16.45 24 16 24.45 16 25C16 25.55 16.45 26 17 26H26.2L24.3 27.9C23.91 28.29 23.91 28.91 24.3 29.3C24.69 29.69 25.31 29.69 25.7 29.3L29.29 25.71C29.68 25.32 29.68 24.69 29.29 24.3L25.7 20.7C25.31 20.31 24.69 20.31 24.3 20.7ZM34 32H27C26.45 32 26 32.45 26 33C26 33.55 26.45 34 27 34H34C35.1 34 36 33.1 36 32V18C36 16.9 35.1 16 34 16H27C26.45 16 26 16.45 26 17C26 17.55 26.45 18 27 18H34V32Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginToPortal);
export default __webpack_public_path__ + "static/media/login_to_portal.ce966d73657fbf1f27d7f2aada4d45f6.svg";
export { ForwardRef as ReactComponent };